<form [formGroup]="formGroup" class="my-4">
  <!-- Title -->
  <h2 *ngIf="title" class="mt-3 mb-3 text-2xl font-semibold">{{ title }}</h2>

  <!-- Address Line 1 -->
  <div class="cipx-form-form-group">
    <mat-form-field class="w-full" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
      <mat-label>{{ defaultLabels.address_street_1_label }}</mat-label>
      <input matInput formControlName="{{ prefix + customPrepend + 'street_1' }}" />

      <mat-error *ngIf="formGroup.get(prefix + customPrepend + 'street_1').hasError('emptyString')">
        Cannot be an empty string.
      </mat-error>
      <mat-error
        *ngIf="
          formGroup.get(prefix + customPrepend + 'street_1')?.hasError('required') &&
          !formGroup.get(prefix + customPrepend + 'street_1')?.valid
        ">
        Value is required.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Address Line 2 -->
  <div class="cipx-form-form-group">
    <mat-form-field class="w-full" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
      <mat-label>{{ defaultLabels.address_street_2_label }}</mat-label>
      <input matInput formControlName="{{ prefix + customPrepend + 'street_2' }}" />
      <mat-error
        *ngIf="
          formGroup.get(prefix + customPrepend + 'street_2')?.hasError('required') &&
          !formGroup.get(prefix + customPrepend + 'street_2')?.valid
        ">
        Value is required.
      </mat-error>
      <mat-error *ngIf="formGroup.get(prefix + customPrepend + 'street_2').hasError('emptyString')">
        Cannot be an empty string.
      </mat-error>
    </mat-form-field>
  </div>

  <!-- City, State, Zip -->
  <div class="cipx-form-form-group">
    <div class="flex flex-col sm:flex-row items-start justify-between sm:gap-2">
      <mat-form-field class="w-full sm:w-1/2" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
        <mat-label>{{ defaultLabels.address_city_label }}</mat-label>
        <input matInput formControlName="{{ prefix + customPrepend + 'city' }}" />
        <mat-error
          *ngIf="
            formGroup.get(prefix + customPrepend + 'city')?.hasError('required') &&
            !formGroup.get(prefix + customPrepend + 'city')?.valid
          ">
          Value is required.
        </mat-error>
        <mat-error *ngIf="formGroup.get(prefix + customPrepend + 'city').hasError('emptyString')">
          Cannot be an empty string.
        </mat-error>
      </mat-form-field>

      @if (showStateLabel) {
        <mat-form-field appearance="fill" class="w-full sm:w-1/6 mt-4 sm:mt-0" hideRequiredMarker="true">
          <mat-label for="state">{{ defaultLabels.address_state_abbreviation_label }}</mat-label>
          <mat-select formControlName="{{ prefix + customPrepend + 'state_abbreviation' }}">
            <mat-option *ngFor="let s of Object.keys(lookupStates)" [value]="s">
              {{ lookupStates[s] }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              formGroup.get(prefix + customPrepend + 'state_abbreviation')?.hasError('required') &&
              !formGroup.get(prefix + customPrepend + 'state_abbreviation')?.valid
            ">
            Value is required.
          </mat-error>
        </mat-form-field>
      } @else {
        <mat-form-field appearance="fill" class="w-full sm:w-1/6 mt-4 sm:mt-0" hideRequiredMarker="true">
          <mat-label for="state">{{ defaultLabels.address_state_abbreviation_label }}</mat-label>
          <mat-select formControlName="{{ prefix + customPrepend + 'state_abbreviation' }}">
            <mat-option *ngFor="let s of Object.keys(lookupStates)" [value]="s">
              {{ s }}
            </mat-option>
          </mat-select>

          <mat-error
            *ngIf="
              formGroup.get(prefix + customPrepend + 'state_abbreviation')?.hasError('required') &&
              !formGroup.get(prefix + customPrepend + 'state_abbreviation')?.valid
            ">
            Value is required.
          </mat-error>
        </mat-form-field>
      }

      <mat-form-field class="w-full sm:mt-0 sm:w-4/12" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
        <mat-label>{{ defaultLabels.address_zip_label }}</mat-label>
        <input matInput formControlName="{{ prefix + customPrepend + 'zip' }}" />

        <mat-error
          *ngIf="
            formGroup.get(prefix + customPrepend + 'zip')?.hasError('required') &&
            !formGroup.get(prefix + customPrepend + 'zip')?.valid
          ">
          Value is required.
        </mat-error>
        <mat-error *ngIf="formGroup.get(prefix + customPrepend + 'zip').hasError('emptyString')">
          Cannot be an empty string.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- County -->
  @if (showCounty) {
    <div class="cipx-form-form-group" *ngIf="formGroup.get(prefix + customPrepend + 'county')">
      <mat-form-field class="w-full" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
        <mat-label>{{ defaultLabels.address_county_label }}</mat-label>
        <input matInput formControlName="{{ prefix + customPrepend + 'county' }}" />
        <mat-error
          *ngIf="
            formGroup.get(prefix + customPrepend + 'county')?.hasError('required') &&
            !formGroup.get(prefix + customPrepend + 'county')?.valid
          ">
          Value is required.
        </mat-error>
        <mat-error *ngIf="formGroup.get(prefix + customPrepend + 'county').hasError('emptyString')">
          Cannot be an empty string.
        </mat-error>
      </mat-form-field>
    </div>
  }

  <!-- Verify Address Button -->
  <div *ngIf="verifyAddressButton" class="my-2">
    <mat-divider></mat-divider>
    <button
      mat-flat-button
      class="mt-2 mb-2 flex-col align-right items-end"
      [color]="'primary'"
      (click)="onVerifyAddress && onVerifyAddress()">
      Verify Address
    </button>
    <mat-divider></mat-divider>
  </div>

  <!-- Address Verified Icon -->
  <div *ngIf="isAddressVerified()" class="my-2">
    <mat-icon>check_circle</mat-icon>
    Address Verified
  </div>
</form>
